import { getAuth0AccessToken } from '../../auth/auth0Client';
import { getGitHubToken } from '../../auth/github';
import { API_BASE_URL } from '../config';
import { AppError, parseErrorResponse } from '../errors';

export async function githubFetch<T>(
  endpoint: string,
  options: { method?: string; body?: unknown } = {}
): Promise<T> {
  const auth0Token = await getAuth0AccessToken();
  const githubToken = getGitHubToken();

  if (!auth0Token) {
    throw new Error('Auth0 authentication required');
  }
  if (!githubToken) {
    throw new Error('GitHub authentication required');
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${auth0Token}`,
    'x-github-access-token': githubToken,
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: options.method ?? 'POST',
    headers,
    body: JSON.stringify(options.body ?? {}),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    if (errorPayload) {
      throw new AppError(errorPayload, response.status);
    }
    throw new Error(`GitHub request failed with status ${response.status}`);
  }

  return response.json() as Promise<T>;
}
